import React, { useState, useEffect, useRef } from 'react';

interface DocumentSearchProps {
  onSearch: (query: string) => void;
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'relative',
    marginBottom: '0.75rem',
  },
  input: {
    width: '100%',
    padding: '0.5rem 2rem 0.5rem 2rem',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    fontSize: '0.85rem',
    outline: 'none',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
  },
  searchIcon: {
    position: 'absolute',
    left: '0.6rem',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '0.85rem',
    color: '#999',
    pointerEvents: 'none',
  },
  clearButton: {
    position: 'absolute',
    right: '0.5rem',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '0.85rem',
    color: '#999',
    padding: '0 0.25rem',
    lineHeight: 1,
  },
};

export function DocumentSearch({ onSearch }: DocumentSearchProps) {
  const [value, setValue] = useState('');
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      onSearch(value.trim());
    }, 300);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [value, onSearch]);

  const handleClear = () => {
    setValue('');
    onSearch('');
  };

  return (
    <div style={styles.container}>
      <span style={styles.searchIcon}>🔍</span>
      <input
        style={styles.input}
        type="text"
        placeholder="Search documents..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      {value && (
        <button style={styles.clearButton} onClick={handleClear} title="Clear search">
          ✕
        </button>
      )}
    </div>
  );
}
